import { VoidCallback } from '@deqo/foundation';
import React, { useCallback } from 'react';
import { TeamWithMembersData, UserLiteData } from '../../../../api/ApiTypes';
import { CommandDispatcher } from '../../../../concepts/commands/CommandDispatcher';
import { Button } from '../../../../ui';
import { useResolve } from '../../../Container';
import { Divider, Flexer } from '../../../dashboard/elements/LayoutElements';
import { workspaceRemoveMember } from '../../../workspace/WorkspaceCommands';
import { UserInfoView } from '../../shared/UserInfoView';

export const TeamMemberInfoView = ({ user, team, readonly, onClose }: { user: UserLiteData, team: TeamWithMembersData, readonly?: boolean, onClose: VoidCallback }) => {

    const dispatch = useResolve(CommandDispatcher);

    const onRemove = useCallback(() => {
        dispatch(workspaceRemoveMember, [user.id, team.id]);
        onClose();
    }, [user.id, team.id, onClose]);

    return <UserInfoView user={user}>
        {!readonly && <Flexer>
            <Divider mode="horizontal" margin=".5 0" />
            <Flexer flex="row" justify="end">
                <Button variant="common" size="sm" onAction={onRemove}>
                    Remove From Team
                </Button>
            </Flexer>
        </Flexer>}
    </UserInfoView>;
};
